module.exports = __webpack_public_path__ + "img/qxsj.cc3fb38a.gif";